import LanguageToggler from '../LanguageToggler/LanguageToggler'
import brandLogoOnLight from '../../images/logo/Dentris-logo-light.png'
import brandLogoOnDark from '../../images/logo/Dentrist-logo-on-dark.png'
import '../../styles/auth.css'

/**
 * Shared shell for public auth pages (login, forgot/reset password).
 * Brand panel + form panel layout; stacks on small screens.
 */
const AuthShell = ({
  eyebrow,
  headline,
  lede,
  title,
  subtitle,
  badge,
  children,
  dir,
  wide = false,
}) => {
  return (
    <div className="auth-shell" dir={dir}>
      <div className="auth-shell__lang">
        <LanguageToggler variant="round" />
      </div>

      <aside className="auth-shell__brand" aria-hidden={false}>
        <div className="auth-shell__brand-inner">
          <img
            src={brandLogoOnDark}
            alt="Dentrist"
            className="auth-shell__logo-mark"
          />
          {eyebrow ? <span className="auth-shell__eyebrow">{eyebrow}</span> : null}
          {headline ? <h1 className="auth-shell__headline">{headline}</h1> : null}
          {lede ? <p className="auth-shell__lede">{lede}</p> : null}
        </div>
      </aside>

      <main className="auth-shell__panel">
        <div
          className="auth-shell__panel-inner"
          style={wide ? { maxWidth: 460 } : undefined}
        >
          <div className="auth-shell__mobile-brand">
            <img src={brandLogoOnLight} alt="Dentrist" />
          </div>

          <header className="auth-shell__header">
            {title ? <h2 className="auth-shell__title">{title}</h2> : null}
            {subtitle ? <p className="auth-shell__subtitle">{subtitle}</p> : null}
            {badge ? <span className="auth-shell__badge">{badge}</span> : null}
          </header>

          <div className="auth-shell__form">{children}</div>
        </div>
      </main>
    </div>
  )
}

export default AuthShell
